import { renderTableTitle } from "@/utils/render.jsx";
import IdentitySettingDrawer from "@/components/Drawer/Identity-setting-Drawer.vue";
import request from "@/service/identity";
export default {
  components: {
    IdentitySettingDrawer
  },
  data() {
    return {};
  },
  computed: {
    height() {
      return window.innerHeight - 200;
    },
    columns() {
      const h = this.$createElement;
      return [{
        title: $t("ibsat14", "身份名称"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        minWidth: 60,
        key: "name",
        align: "center",
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("g2z7o64", "管理范围"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        minWidth: 60,
        key: "managementScope",
        align: "center",
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("cwn7sh4", "拥有权限"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        minWidth: 60,
        key: "power",
        align: "center",
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("cfo21v5", "最后操作人"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        minWidth: 60,
        key: "modifyUser",
        align: "center",
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("uc0ptx6", "最后操作时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        minWidth: 60,
        key: "modifyDatetime",
        align: "center",
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "action",
        minWidth: 60,
        align: "center",
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => {
          return h("div", {
            "class": "flex gap-2"
          }, [h("a", {
            "class": "text-[var(--secondary,#785a1a)] hover:underline cursor-pointer",
            "on": {
              "click": async () => {
                this.editIdentity(row);
              }
            }
          }, [$t("mekb2", "编辑")]), h("a", {
            "class": "text-[var(--error,#c0392b)] hover:underline cursor-pointer",
            "on": {
              "click": async () => {
                this.removeIdentity(row);
              }
            }
          }, [$t("eslg2", "删除")])]);
        }
      }];
    },
    toolBarActions() {
      const h = this.$createElement;
      return [{
        renderItem: () => {
          return h("Button", {
            "attrs": {
              "type": "primary"
            },
            "on": {
              "click": async () => {
                this.addIdentity();
              }
            }
          }, [$t("d7e1pc4", "新增身份")]);
        }
      }];
    },
    config() {
      return {
        //配置项
        autoFetch: false,
        columns: this.columns,
        hide: {
          search: true
        },
        table: {
          draggable: false,
          height: this.height
        },
        toolBarActions: this.toolBarActions,
        //   search: false,
        request: async params => {
          let {
            datas,
            firstResult,
            pageSize,
            totalRows
          } = await this.findIdentityPage(params);
          console.log();
          return {
            list: datas,
            pageNum: firstResult / pageSize + 1,
            pageSize,
            total: totalRows
          };
        },
        map: {
          dataPath: "list",
          totalPath: "total",
          current: "pageNum",
          pageSize: "pageSize"
        }
        // hide: { toolBar: true },
      };
    }
  },
  methods: {
    addIdentity() {
      this.$refs.drawerRef.open($t("d7e1pc4", "新增身份"), {});
    },
    editIdentity() {
      this.$refs.drawerRef.open($t("gmrh9p4", "编辑身份"), {});
    },
    removeIdentity(item) {
      this.$Modal.confirm({
        title: $t("8ddcgr5", "确认删除？"),
        onOk: async () => {
          console.log(item);

          // let res = await request.removeUserIdentity()
          // todo
          this.fetchData();
        }
      });
    },
    async findIdentityPage() {
      let {
        data: {
          retVal: {
            datas,
            firstResult,
            pageSize,
            totalRows
          }
        }
      } = await request.findIdentityPage({});
      return {
        datas,
        firstResult,
        pageSize,
        totalRows
      };
    }
  },
  mounted() {
    this.$refs.proTableRef.fetch();
  }
};